import { BaseRequest } from './BaseRequest';

export class OrleansRequest extends BaseRequest {
    
}